import React, { useEffect, useState } from 'react';
import BiButton from './BiButton';

const BiColorPicker = ({ name, value, onChange, disabled }) => {


    const [color, setColor] = useState("");

    useEffect(() => {
        if (value != null) {
            let bar = value;
            if (bar.length > 7) {
                bar = bar.replace("#FF", "#");
            }
            setColor(bar);
        } else {
            setColor("#FFFFFF");
        }
    }, [value]);
    const onChanged = (e) => {

        setColor(e.target.value)

        let bar = e.target.value;
        if (bar.length == 7) {
            bar = bar.replace("#", "#FF");
        }

        onChange({ target: { name: name, value: bar } });
    }

    const removeColor = () => {
        setColor("#FFFFFF")
        onChange({ target: { name: name, value: null } });
    }

    return (
        <div style={{ width: "80px", display: "block" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <input
                    type="color"
                    className="form-control form-control-sm biControlInline"
                    name={name}
                    onBlur={(e) => onChanged(e)}
                    onChange={(e) => setColor(e.target.value)}
                    value={color}
                />
                <BiButton icon="fas fa-trash" onClick={removeColor}></BiButton>
            </div>
        </div>
    );
}

export default BiColorPicker;

